/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { SiriusIconComponent } from "./components/sirius-icon.web-component";
export class SiriusIcon {
    static register() {
        if (!customElements.get(SiriusIconComponent.CUSTOM_ELEMENT_NAME)) {
            customElements.define(SiriusIconComponent.CUSTOM_ELEMENT_NAME, SiriusIconComponent);
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lyaXVzLWljb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL2ljb25zL3Npcml1cy1pY29uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsT0FBTyxFQUFDLG1CQUFtQixFQUFDLE1BQU0sd0NBQXdDLENBQUM7QUFFM0UsTUFBTSxPQUFPLFVBQVU7SUFDWixNQUFNLENBQUMsUUFBUTtRQUNsQixJQUFJLENBQUMsY0FBYyxDQUFDLEdBQUcsQ0FBQyxtQkFBbUIsQ0FBQyxtQkFBbUIsQ0FBQyxFQUFFO1lBQzlELGNBQWMsQ0FBQyxNQUFNLENBQUMsbUJBQW1CLENBQUMsbUJBQW1CLEVBQUUsbUJBQW1CLENBQUMsQ0FBQztTQUN2RjtJQUNMLENBQUM7Q0FDSiJ9